export const DEFAULT_BRANCH_ID = process.env.REACT_APP_DEFAULT_BRANCH_ID
export const DEFAULT_SESSION = process.env.REACT_APP_DEFAULT_SESSION
export const ADMISSION_FEE_GROUP = process.env.REACT_APP_ADMISSION_FEE_GROUP
export const TUITION_FEE_GROUP = process.env.REACT_APP_TUITION_FEE_GROUP
export const ACADEMIC_NAME = "THE EON ACADEMY"
export const YEARS = ["2025-2026", "2024-2025", "2023-2024", "2022-2023"]
export const SYSTEM_ROLES = {
  student: "student",
  parent: "parent",
  teacher: "teacher",
  owner: "owner",
  cashier: "cashier",
}

export const MAP_STATUS = {
  active: "Active",
  inactive: "Inactive",
}

export const MONTHS = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
]

export const CONDITIONS = {
  NEW: "new",
  EXCELLENT: "excellent",
  GOOD: "good",
  FAIR: "fair",
} as const

export const BOOK_CONDITIONS = [
  { value: CONDITIONS.NEW, label: "New" },
  { value: CONDITIONS.EXCELLENT, label: "Excellent" },
  { value: CONDITIONS.GOOD, label: "Good" },
  { value: CONDITIONS.FAIR, label: "Fair" },
]

export const RECIPIENT_TYPES = {
  STUDENT: "student",
  STAFF: "staff",
} as const

export const RECIPIENT_TYPE_OPTIONS = [
  { value: RECIPIENT_TYPES.STUDENT, label: "Student" },
  { value: RECIPIENT_TYPES.STAFF, label: "Staff" },
]
